import $ from 'jquery';

// bitters/_layout.scss sets `scroll-behavior: smooth` on <html>. That CSS
// smoothing intercepts every scrollTop change jQuery's animate() makes as its
// own separate smooth-scroll request, so the two fight each other and the
// page settles somewhere between the native position and the offset target
// instead of at it. Toggle scroll-behavior off for the duration of our own
// animation (same fix Fancybox's own vendor CSS applies via `.with-fancybox`).
function scrollToOffset(target, offset) {
	var html = document.documentElement;
	var previousScrollBehavior = html.style.scrollBehavior;
	html.style.scrollBehavior = 'auto';

	$('html, body').animate(
		{
			scrollTop: target.offset().top - offset,
		},
		250,
		function () {
			html.style.scrollBehavior = previousScrollBehavior;
		}
	);
}

export default {
	init() {
		$(function () {
			// Select all anchor links that point to an ID on the same page
			$('a[href*="#"]:not([href="#"],[href*="fancybox-lightbox"])').on(
				'click',
				function (event) {
					// Ensure the link is for an internal anchor
					if (
						location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
						location.hostname == this.hostname
					) {
						var target = $(this.hash); // Get the target element using the hash
						target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Fallback for name attribute
						if (target.length) {
							// Without this, the browser's native anchor jump fires at the
							// same time as scrollToOffset() below and the two fight over
							// scrollTop, landing somewhere between the two instead of at
							// the offset.
							event.preventDefault();
							scrollToOffset(target, 150); // 150 = height of the sticky header
						}
					}
				}
			);
			$(window).on('load', function () {
				// If there's a hash in the URL on page load, scroll to it with offset
				if (window.location.hash) {
					var target = $(window.location.hash);
					target = target.length
						? target
						: $('[name=' + window.location.hash.slice(1) + ']');
					if (target.length) {
						scrollToOffset(target, 150);
					}
				}
			});
		});
	},
};
